import React, { useState, useEffect, useRef, useCallback } from 'react';
import Icon from 'atomic/icon';
import useToggle from 'hooks/use-toggle';
import DepartmentMenu from './components/department-menu/department-menu';
import MenuOverlay from 'modules/shared/layout/menu/menu-overlay/menu-overlay';
import { useScrollLock } from 'hooks/use-scroll-lock';
import useResizeObserver from 'hooks/use-resize-observer';
import getElementTopOffset from 'helpers/get-element-top-offset';

import './menu-desktop.scss';

const MenuDesktop: React.FC = () => {
    const [isOpenMenu, menuState] = useToggle(false);
    const { lock, unlock } = useScrollLock();
    const body = useRef<HTMLBodyElement | null>(null);
    const [menuTopPosition, setMenuTopPosition] = useState(92);

    useEffect(() => {
        body.current = document.querySelector('body');
    }, []);

    useEffect(() => {
        if (isOpenMenu) {
            lock();
            document.documentElement.scrollTop = window.scrollY;
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
            unlock();
        }
    }, [isOpenMenu, lock, unlock]);

    const onResize = useCallback(() => {
        const topBar = document.getElementById('top-bar');

        if (topBar) {
            const { height: topBarHeight } = topBar.getBoundingClientRect();
            const topBarTopOffset = getElementTopOffset(topBar as HTMLElement);

            setMenuTopPosition(topBarTopOffset + topBarHeight);
        }
    }, []);

    useResizeObserver(onResize);

    return (
        <>
            <div className="menu-desktop">
                <div className="menu-desktop__button" role="button" onClick={(): void => menuState.toggle()}>
                    <Icon className="burger" name="burger" size={20}
                        color="secondary"
                    />
                    Kategorie
                    <Icon
                        className="chevron"
                        name={isOpenMenu ? 'chevron-up' : 'chevron-down'}
                        size={20}
                        color="secondary"
                    />
                    {isOpenMenu}
                </div>
                <DepartmentMenu
                    onClose={menuState.toggle}
                    isOpenMenu={isOpenMenu}
                    topPosition={menuTopPosition}
                />
            </div>
            {isOpenMenu && <MenuOverlay onClose={menuState.toggle} topPosition={menuTopPosition} />}
        </>
    );
};

export default MenuDesktop;
